import { useTranslation } from "react-i18next";
import PanelsLayout from "components/PanelsLayout";
import { useContext, useState } from "react";
import styles from "./styles.module.scss";
import { useDebounce } from "use-debounce";
import { IssuesList } from "./issuesList";
import { AbilityContext } from "contexts/AbilityContext";
import IssuesGrid from "components/IssuesGrid";

const HelpdeskModule = () => {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const [searchText, setSearchText] = useState("");
  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const leftPanel = () => {
    if (ability && ability.can("accessModule", "admin")) {
      return <IssuesGrid searchText={searchText}></IssuesGrid>;
    }
    // if (view === "edelivery") {
    //   return (
    //     <MessagesRegister
    //       kind={ItemKind.EDeliveryMessage}
    //       searchText={debouncedText}
    //     ></MessagesRegister>
    //   );
    // }

    return (
      <IssuesList
        searchText={searchText}
        debouncedText={debouncedText}
      ></IssuesList>
    );
  };

  const getLeftPanelTitle = () => {
    return t("helpdesk.title");
  };

  const getLeftPanelSubtitle = () => {
    return t("helpdesk.issuesList");
  };

  const rightPanel = () => {
    null;
  };

  return (
    <PanelsLayout
      title={getLeftPanelTitle()}
      subTitle={getLeftPanelSubtitle()}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={leftPanel()}
      leftClassName={styles.leftPanel}
      hideRight={true}
      rightPanel={rightPanel()}
    />
  );
};
export default HelpdeskModule;
